import React from 'react'

/**
 * PartySelectionCard — single radio-style card on Step 1.
 * Mirrors Scale's UpdateInvoice/common/PartySelectionCard with disabled-state
 * styling + tooltip + click-when-disabled handler that fires a toast.
 */
function fmtMoney(n) {
    const v = Number(n) || 0
    return v.toLocaleString('en-US', { style: 'currency', currency: 'USD' })
}

export default function PartySelectionCard({
    label,
    subtext,
    selected,
    disabled,
    disabledReason,
    onSelect,
    onClickWhenDisabled,
}) {
    const handleClick = () => {
        if (disabled) {
            if (typeof onClickWhenDisabled === 'function') onClickWhenDisabled()
            return
        }
        onSelect()
    }

    const cardCls = `
        relative w-full text-left p-4 border rounded-lg transition-colors
        ${disabled
            ? 'border-gray-200 bg-gray-50 cursor-not-allowed text-gray-400'
            : selected
                ? 'border-transparent text-white shadow-sm'
                : 'border-gray-200 hover:border-gray-300 bg-white'}
    `.trim()

    const cardStyle = selected && !disabled
        ? { background: 'linear-gradient(90deg, #115E59 0%, #0F766E 100%)' }
        : {}

    return (
        <button
            type="button"
            onClick={handleClick}
            title={disabled && disabledReason ? disabledReason : ''}
            className={cardCls}
            style={cardStyle}
        >
            <div className="flex items-start gap-3">
                <span className={`mt-0.5 w-4 h-4 rounded-full border ${disabled ? 'border-gray-300' : selected ? 'border-white' : 'border-gray-400'} flex items-center justify-center shrink-0`}>
                    {selected && !disabled ? <span className="w-2 h-2 rounded-full bg-white" /> : null}
                </span>
                <div className="flex-1 min-w-0">
                    <div className={`font-bold text-[15px] ${disabled ? 'text-gray-400' : selected ? 'text-white' : 'text-gray-900'}`}>
                        {label}
                    </div>
                    {subtext ? (
                        <div className={`text-[13px] mt-0.5 ${disabled ? 'text-gray-400' : selected ? 'text-white/90' : 'text-gray-500'}`}>
                            {subtext}
                        </div>
                    ) : null}
                </div>
            </div>
        </button>
    )
}

export { fmtMoney }
